import { createModalDownload } from "../components/modal-download";

createModalDownload("#title-call-download-download-button");
